import { render, staticRenderFns } from "./PorletMenuPrincipal.vue?vue&type=template&id=2d259cb2"
import script from "./PorletMenuPrincipal.vue?vue&type=script&lang=js"
export * from "./PorletMenuPrincipal.vue?vue&type=script&lang=js"
import style0 from "./PorletMenuPrincipal.vue?vue&type=style&index=0&id=2d259cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports